import { useTranslation } from "@coworker/locales";
import {
  FilterType,
  FilterValue,
  InputType,
  MultiSelectFilter,
  RowVisibility,
} from "../../../shared/filters/types/filter";
import type { ApplyFilter } from "../../../shared/filters/types/apply";
import type { Launch } from "../../types/launch";
import {
  matchesSelection,
  type LaunchMediaRow,
} from "../../utils/launchMediaFilters";

const LAUNCH_ID = "launch";

export function useLaunchMultiSelectFilter(
  launches: Launch[]
): ApplyFilter<MultiSelectFilter, LaunchMediaRow> {
  const { t } = useTranslation();
  const ids = launches.map((l) => l.id);

  return {
    filter: {
      inputType: InputType.MultiSelect,
      filterType: FilterType.Filter,
      id: LAUNCH_ID,
      title: t("launchLabelString"),
      options: launches.map((l) => ({ value: l.id, title: l.name })),
      enabled: true,
      showSearch: true,
      rowVisibility: RowVisibility.PillOnly,
      defaultValue: { filterId: LAUNCH_ID, value: [] },
    },
    filterCompare: ({ launch }: LaunchMediaRow, { value }: FilterValue) =>
      matchesSelection(value, ids, launch.id),
  };
}
